import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { PriceSwitcherService } from "libraries/component/tab-navigation/price-switcher.service";
import { EXRateType } from "libraries/interfaces/ITotal";
import { Subscription } from "rxjs";

class Wording {
    public readonly cost: string = Yii.t('wui-shared-js', "Prix d'achat");
    public readonly retail: string = Yii.t('wui-shared-js', "Prix de vente");
}

@Component({
    selector: 'price-switcher',
    template: `
        <ul class="columns" *ngIf="hasPriceSwitcher">
            <li *ngIf="hasSeparatorBefore" class="tab separator-before">
            </li>
            <li class="tab"
                [class.selected]="selectedPriceType === types.cost"
                (click)="showPrice(types.cost)">
                    <span>
                        {{ wording.cost }}
                    </span>
            </li>
            <li class="tab"
                [class.selected]="selectedPriceType === types.retail"
                (click)="showPrice(types.retail)">
                    <span>
                        {{ wording.retail }}
                    </span>
            </li>
        </ul>
    `,
    styleUrls: ['./tab-navigation.scss']
})

export class PriceSwitcherComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input()
    public hasSeparatorBefore: boolean;

    public hasPriceSwitcher: boolean;
    public types: typeof EXRateType = EXRateType;
    public selectedPriceType: EXRateType;

    public wording: Wording = new Wording();
    public subscription: Subscription = new Subscription();

    constructor(
        private readonly priceSwitcherService: PriceSwitcherService,
    ) {
    }

    public ngOnInit(): void {
        this.selectedPriceType = this.priceSwitcherService.selectedPrice || EXRateType.cost;
        this.priceSwitcherService.hasPriceSwitcherPermission = true;
        this.hasPriceSwitcher = this.priceSwitcherService.hasPriceSwitcher;
        this.subscription
            .add(
                this.priceSwitcherService.selectPriceEvent
                    .subscribe((selectedPrice: EXRateType): void => {
                        this.selectedPriceType = selectedPrice;
                    })
            )
            .add(
                this.priceSwitcherService.hasPriceSwitcherEvent
                    .subscribe((hasPriceSwitcher: boolean): void => {
                        this.hasPriceSwitcher = hasPriceSwitcher;
                    })
            );

    }

    public ngAfterViewInit() {
        this.showPrice(EXRateType.cost);
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }


    public showPrice(priceType: EXRateType): void {
        this.priceSwitcherService.selectPrice(priceType);
    }
}
